// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-wrapper{
    position: relative;
    opacity: 1;
}

.modal-mapbtn{
    position: absolute;
    z-index: 1;
    top: 10px;
    right:10px;
    width: 40px;
    height: 40px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border-radius: 10px;
    opacity: 1;
    border: none;
    background-image: url('close-button.svg');
    background-position: center;
}

.modal-search{
    position: absolute;
    top: 10px;
    left: 10px;
    z-index: 2;
}

.modal-display-msg{
    position: absolute;
    z-index: 3;
    bottom: 10px;
    left: 10px;
    background-color: #FFFFFF;
    color: #2C906B;
    align-content: center;
    font-size: 18px;
    padding: 8px 8px;
    border-radius: 10px;
}

#map {
    width: 80vw;
    height: 80vh;
    z-index: 0;
}

.mapError {
    width: 500px;
    height: 200px;
    text-align: center;
    z-index: 0;
    padding-top: 60px;
    color: #2C906B;
    font-weight: bold;
}

.map-wrapper{
    background-color: #FFFFFF;
    border-radius: 16px !important;
    position: relative
}

.modal-display-error{
    position: absolute;
    z-index: 3;
    bottom: 60px;
    left: 10px;
    background-color: #FFFFFF;
    color: #2C906B;
    align-content: center;
    font-size: 18px;
    padding: 8px 8px;
    border-radius: 10px;
}

.modal-confirmation-display{
    position: absolute;
    z-index: 4;
    top: 200px;
    left: 500px;
    right: 500px;
    background-color: #FFFFFF;
    color: #2C906B;
    align-content: center;
    font-size: 18px;
    padding: 8px 8px;
    border-radius: 20px;
}

/**.ol-marker {
    width: 10px;
    height: 10px;
    background-image: url('../../../../assets/img/destination-marker.svg');
    border: 1px solid #088;
    border-radius: 10px;
    background-color: #0FF;
    opacity: 0.5;
    cursor: move;
}*/

/**
.center{
    position: absolute;
    z-index: 6;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border: solid 1px black;
    height: 10px;
    width: 10px;
}

.center-marker{
    position: absolute;
    z-index: 5;
    left: 50%;
    top: 42.2%;
    transform: translate(-50%, -50%);
    height: 51px;
    width: 37px;
    background-image: url("../../../../assets/img/blue-marker-modal.svg");
}*/`, "",{"version":3,"sources":["webpack://./src/app/shared/modals/map/map.component.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,mEAAmE;IACnE,+CAA+C;IAC/C,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,yCAA8D;IAC9D,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B;AACJ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,cAAc;IACd,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;;;;;;;;EASE;;AAEF;;;;;;;;;;;;;;;;;;;;;EAqBE","sourcesContent":[".modal-wrapper{\n    position: relative;\n    opacity: 1;\n}\n\n.modal-mapbtn{\n    position: absolute;\n    z-index: 1;\n    top: 10px;\n    right:10px;\n    width: 40px;\n    height: 40px;\n    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border-radius: 10px;\n    opacity: 1;\n    border: none;\n    background-image: url(../../../../assets/img/close-button.svg);\n    background-position: center;\n}\n\n.modal-search{\n    position: absolute;\n    top: 10px;\n    left: 10px;\n    z-index: 2;\n}\n\n.modal-display-msg{\n    position: absolute;\n    z-index: 3;\n    bottom: 10px;\n    left: 10px;\n    background-color: #FFFFFF;\n    color: #2C906B;\n    align-content: center;\n    font-size: 18px;\n    padding: 8px 8px;\n    border-radius: 10px;\n}\n\n#map {\n    width: 80vw;\n    height: 80vh;\n    z-index: 0;\n}\n\n.mapError {\n    width: 500px;\n    height: 200px;\n    text-align: center;\n    z-index: 0;\n    padding-top: 60px;\n    color: #2C906B;\n    font-weight: bold;\n}\n\n.map-wrapper{\n    background-color: #FFFFFF;\n    border-radius: 16px !important;\n    position: relative\n}\n\n.modal-display-error{\n    position: absolute;\n    z-index: 3;\n    bottom: 60px;\n    left: 10px;\n    background-color: #FFFFFF;\n    color: #2C906B;\n    align-content: center;\n    font-size: 18px;\n    padding: 8px 8px;\n    border-radius: 10px;\n}\n\n.modal-confirmation-display{\n    position: absolute;\n    z-index: 4;\n    top: 200px;\n    left: 500px;\n    right: 500px;\n    background-color: #FFFFFF;\n    color: #2C906B;\n    align-content: center;\n    font-size: 18px;\n    padding: 8px 8px;\n    border-radius: 20px;\n}\n\n/**.ol-marker {\n    width: 10px;\n    height: 10px;\n    background-image: url('../../../../assets/img/destination-marker.svg');\n    border: 1px solid #088;\n    border-radius: 10px;\n    background-color: #0FF;\n    opacity: 0.5;\n    cursor: move;\n}*/\n\n/**\n.center{\n    position: absolute;\n    z-index: 6;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    border: solid 1px black;\n    height: 10px;\n    width: 10px;\n}\n\n.center-marker{\n    position: absolute;\n    z-index: 5;\n    left: 50%;\n    top: 42.2%;\n    transform: translate(-50%, -50%);\n    height: 51px;\n    width: 37px;\n    background-image: url(\"../../../../assets/img/blue-marker-modal.svg\");\n}*/"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
